import LoginView from "../Vue/Pages/LoginView";

const LoginController = () => {
  return (LoginView())
}

export default LoginController;